<!-- <div class="mx-auto w-full"> -->
    <dl class="w-full grid grid-cols-1 gap-3 sm:grid-cols-8">
        <div class="overflow-hidden rounded-lg dark:bg-gray-800 bg-gray-100 px-4 py-2">
            <dt class="truncate text-sm font-medium text-secondary">Audience</dt>
            <dd class="w-full flex flex-row justify-between items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="text-primary size-5">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <path d="M16 3.128a4 4 0 0 1 0 7.744" />
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                    <circle cx="9" cy="7" r="4" />
                </svg>
                <p class="text-lg font-semibold tracking-tight text-primary">{{
                    formatService.convertIntToString(totalAudience) }}</p>
            </dd>
        </div>
        <div class="overflow-hidden rounded-lg dark:bg-gray-800 bg-gray-100 px-4 py-2">
            <dt class="truncate text-sm font-medium text-secondary">Posts</dt>

            <dd class="w-full flex flex-row justify-between items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="text-primary size-5">
                    <circle cx="12" cy="12" r="10" />
                    <circle cx="12" cy="12" r="6" />
                    <circle cx="12" cy="12" r="2" />
                </svg>
                <p class="text-lg font-semibold tracking-tight text-primary">{{
                    formatService.convertIntToString(totalPosts || 0) }}</p>
            </dd>
        </div>
        <div class="overflow-hidden rounded-lg dark:bg-gray-800 bg-gray-100 px-4 py-2">
            <dt class="truncate text-sm font-medium text-secondary">Views</dt>

            <dd class="w-full flex flex-row justify-between items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="text-primary size-5">
                    <path
                        d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
                    <circle cx="12" cy="12" r="3" />
                </svg>
                <p class="text-lg font-semibold tracking-tight text-primary">{{
                    formatService.convertIntToString(totalViews) }}</p>
            </dd>
        </div>
        <div class="overflow-hidden rounded-lg dark:bg-gray-800 bg-gray-100 px-4 py-2">
            <dt class="truncate text-sm font-medium text-secondary">Likes</dt>


            <dd class="w-full flex flex-row justify-between items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="text-primary size-5">
                    <path
                        d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5" />
                </svg>
                <p class="text-lg font-semibold tracking-tight text-primary">{{
                    formatService.convertIntToString(totalLikes) }}</p>
            </dd>
        </div>
        <div class="overflow-hidden rounded-lg dark:bg-gray-800 bg-gray-100 px-4 py-2">
            <dt class="truncate text-sm font-medium text-secondary">Comments</dt>


            <dd class="w-full flex flex-row justify-between items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="text-primary size-5">
                    <path
                        d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719" />
                </svg>
                <p class="text-lg font-semibold tracking-tight text-primary">{{
                    formatService.convertIntToString(totalComments) }}</p>
            </dd>
        </div>
        <div class="overflow-hidden rounded-lg dark:bg-gray-800 bg-gray-100 px-4 py-2">
            <dt class="truncate text-sm font-medium text-secondary">Saves</dt>


            <dd class="w-full flex flex-row justify-between items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="text-primary size-5">
                    <path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z" />
                </svg>
                <p class="text-lg font-semibold tracking-tight text-primary">{{
                    formatService.convertIntToString(totalSaves) }}</p>
            </dd>
        </div>
        <div class="overflow-hidden rounded-lg dark:bg-gray-800 bg-gray-100 px-4 py-2">
            <dt class="truncate text-sm font-medium text-secondary">Shares</dt>


            <dd class="w-full flex flex-row justify-between items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="text-primary size-5">
                    <circle cx="18" cy="5" r="3" />
                    <circle cx="6" cy="12" r="3" />
                    <circle cx="18" cy="19" r="3" />
                    <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
                    <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
                </svg>
                <p class="text-lg font-semibold tracking-tight text-primary">{{
                    formatService.convertIntToString(totalShares) }}</p>
            </dd>
        </div>
        <div class="overflow-hidden rounded-lg dark:bg-gray-800 bg-gray-100 px-4 py-2">
            <dt class="truncate text-sm font-medium text-secondary">Engagements</dt>


            <dd class="w-full flex flex-row justify-between items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="text-primary size-5">
                    <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" />
                    <path
                        d="M8.62 9.8A2.25 2.25 0 1 1 12 6.836a2.25 2.25 0 1 1 3.38 2.966l-2.626 2.856a.998.998 0 0 1-1.507 0z" />
                </svg>
                <p class="text-lg font-semibold tracking-tight text-primary">{{
                    formatService.convertIntToString(totalEngagements) }}</p>
            </dd>
        </div>
    </dl>
<!-- </div> -->